import{jsxs as t,jsx as e}from"react/jsx-runtime";import{styled as r}from"styled-components";import{TabItem as m}from"./components/TabItem.mjs";import{Tabs as n}from"./components/Tabs.mjs";import{useItemNames as o}from"../../../domain/hooks/useItemName.mjs";import{useGuideTab as a}from"../../context/GuideTabContext.mjs";import{SUPPORT_AREA as i}from"./constants/ElementId.mjs";import{titleName as s}from"../../../domain/domain/UI/Title.name.mjs";const b=r.div`
  width: 300px;
  margin-left: 6px;
  position: fixed;
  top: 41px;
  right: 8px;
  overflow: visible;
  z-index: 6;
`,u=r.ul`
  padding: 0px;
  margin: 0px;
  list-style: none;
`;function d(){const r=o(s),{currentTab:d,setCurrentTab:p}=a();return t(b,{id:i,className:"tabs",children:[t(u,{className:"tabs-nav",children:[e(m,{title:r("guide"),tab:"guide",currentTab:d,setCurrentTab:p,aId:"guide-tab"}),e(m,{title:r("job"),tab:"job",currentTab:d,setCurrentTab:p,aClassName:"usual",aId:"job-tab"}),e(m,{title:r("myMenu"),tab:"myMenu",currentTab:d,setCurrentTab:p,aId:"my-menu-tab"})]}),e(n,{currentTab:d})]})}export{d as SupportArea};
